import '@/assets/static/css/main.scss';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/common/utils/NativeCall';
import '@/common/utils/module/NativeRequest';
import VueScrollTo from 'vue-scrollto';
import { ObserveVisibility } from 'vue-observe-visibility';
import { extendConsole } from '@/common/utils/module/Override';

extendConsole();
const app = createApp(App);

// 전역 컴포넌트 등록
app.directive('skeleton', {
  mounted: (el, binding, vnode, prevVNode) => {
    const { value } = binding;
    const { data, target } = value;
    if (!data || !target || (target ?? []).length == 0) throw Error(' YOU MUST INPUT DATA AND TARGET');

    const isLoaded = target
      .map(elem => {
        if (elem.includes('.')) {
          const arr = elem.split('.');
          return !!arr.reduce((p, n) => {
            return p[n];
          }, data);
        } else return !!data[elem];
      })
      .reduce((p, n) => {
        return p && n;
      }, true);

    if (!isLoaded) el.classList.value += ' skeleton';
  },
  updated: (el, binding, vnode, prevVNode) => {
    const { value } = binding;
    const { data, target } = value;
    if (!data || !target || (target ?? []).length == 0) throw Error(' YOU MUST INPUT DATA AND TARGET');

    const isLoaded = target
      .map(elem => {
        if (elem.includes('.')) {
          const arr = elem.split('.');
          return !!arr.reduce((p, n) => {
            return p[n];
          }, data);
        } else return !!data[elem];
      })
      .reduce((p, n) => {
        return p && n;
      }, true);
    if (isLoaded) el.classList.value = el.classList.value.replaceAll(/skeleton/gi, '');
  }
});
app.directive('$router', router);
app.directive('observe-visibility', ObserveVisibility);
app.directive('save-position', {
  mounted: (el, binding, vnode, prevVNode) => {
    console.log('Test');
    el.classList += ` save-position${location.pathname}`;
  }
});
app.directive('scrollable', {
  mounted: (el, binding, vnode, prevVNode) => {
    el.classList += ` scroll-view`;
  }
});

window.Kakao.init('43232041f25d1ab3431a1fac4ce4c9fc');
console.log('Kakao init ::', window.Kakao.isInitialized());

app
  .use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  })
  .use(store)
  .use(router)
  .mount('#app');
